<template>
  <div class="grid-view">
    <div class="main-content" style="margin-left: 10px;">
      <search-item
        config-module="101701"
        :show-more-scheme="true"
        :show-simple="showSimple"
        :expand-adv="true"
        sim-url=""
        adv-url=""
        @query="toQuery"
      >
        <div slot="operations">
          <el-button type="primary" @click="addHandler">{{ $t('common.btn.new') }}</el-button>
          <el-button type="primary" @click="editHandler">{{ $t('common.btn.edit') }}</el-button>
          <el-button type="danger" @click="removeHandler">{{ $t('common.btn.delete') }}</el-button>
        </div>
      </search-item>
      <div class="section grid-wrapper">
        <cargo-ag-grid
          :grid-params.sync="gridParams"
          :grid-options="gridOptions"
          :column-defs="columnDefs"
          :row-data="rowData"
        />
      </div>
      <div class="pagination-wrapper">
        <cargo-pagination
          :total="pageConditions.total"
          :page.sync="pageConditions.pageNum"
          :limit.sync="pageConditions.pageSize"
          @pagination="toQuery"
        />
      </div>
      <!--新增/编辑 弹窗-->
      <form-dialog
        :visible.sync="formDialog.visible"
        :is-edit="formDialog.isEdit"
        :uuid="formDialog.uuid"
        @saveCallBack="saveCallBackHandler"
        @close="formDialog.visible=false"
      />
    </div>
  </div>
</template>

<script>
import searchItem from '@/components/Cargo/Common/cargoCombinationSearch'
import formDialog from '@/views/cargo/v0/Information/components/mscHistoryBillAddress/FormDialog'
import * as mscHistoryBillAddressApi from '@/api/basicData/mscHistoryBillAddress'
import { getLoading } from '@/utils/utilBaseElement'
import AdvancedSearchOption from '@/class/cargo/model/parameters/AdvancedSearchOption'
import * as AdvancedSearchConsts from '@/class/cargo/model/utils/AdvancedSearchConsts'
import { exportExcel, exportPdf } from '@/utils/tableDataExportUtils'

export default {
  name: 'FmMSCHistoryBillAddress',
  components: { searchItem, formDialog },
  data() {
    return {
      showSimple: true,
      rowData: [],
      gridParams: {},
      gridOptions: {
        rowSelection: 'multiple',
        defaultColDef: {
          resizable: true
        },
        context: {
          componentParent: this
        },
        suppressContextMenu: false, // 右键列表弹出菜单
        getContextMenuItems: (params) => {
          const self = this
          return [
            {
              name: self.$t('CargoMsg.Cargo_ExcelExport') + '(当前选择)',
              action: function() {
                self.exportExcelSelectedHandler()
              }
            },
            {
              name: self.$t('CargoMsg.Cargo_ExcelExport') + '(当前页)',
              action: function() {
                self.exportExcelHandler()
              }
            },
            {
              name: self.$t('CargoMsg.Cargo_DataExportPDF') + '(当前选择)',
              action: function() {
                self.exportPdfSelectedHandler(params)
              }
            },
            {
              name: self.$t('CargoMsg.Cargo_DataExportPDF') + '(当前页)',
              action: function() {
                self.exportPdfHandler(params)
              }
            }
          ]
        }
      },
      columnDefs: [
        {
          headerName: '',
          headerCheckboxSelection: true,
          checkboxSelection: true,
          width: 55,
          sortable: false,
          suppressMenu: true,
          suppressSizeToFit: true,
          resizable: false
        }, {
          headerName: this.$t('SeaExport.CompanyName'),
          field: 'companyName',
          width: 150
        }, {
          headerName: this.$t('SeaExport.GroupCode'),
          field: 'groupCode',
          width: 150
        }, {
          headerName: this.$t('SeaExport.CompanyAddress'),
          field: 'companyAddress',
          width: 150
        }, {
          headerName: this.$t('SeaExport.City'),
          field: 'cityName',
          width: 150
        }, {
          headerName: this.$t('SeaExport.ZipCode'),
          field: 'zipCode',
          width: 150
        }, {
          headerName: this.$t('SeaExport.Contact'),
          field: 'contact',
          width: 150
        }, {
          headerName: this.$t('SeaExport.Tel'),
          field: 'phone',
          width: 150
        }, {
          headerName: this.$t('SeaExport.Fax'),
          field: 'fax',
          width: 150
        }, {
          headerName: this.$t('SeaExport.VipCode'),
          field: 'vipCode',
          width: 150
        }, {
          headerName: this.$t('SeaExport.MscCode'),
          field: 'mscCode',
          width: 150
        }, {
          headerName: this.$t('SeaExport.InttraCode'),
          field: 'inttraCode',
          width: 150
        }, {
          headerName: this.$t('SeaExport.OtherInformation'),
          field: 'otherInformation',
          width: 150
        }, {
          headerName: this.$t('SeaExport.BlTitle'),
          field: 'blTitle',
          width: 150
        }, {
          headerName: this.$t('SeaExport.BlAddress'),
          field: 'blAddress',
          width: 150
        }, {
          headerName: this.$t('SeaExport.BlContact'),
          field: 'blContact',
          width: 150
        }
      ],
      pageConditions: {
        total: 0,
        pageNum: 1,
        pageSize: 10
      },
      lastConditions: [],
      formDialog: {
        visible: false,
        isEdit: false,
        uuid: ''
      }
    }
  },
  methods: {
    toQuery(param) {
      const params = {}
      if (param) {
        if (param.simpleTriggerMode) {
          params.conditions = [new AdvancedSearchOption('FIELD_TEXT', 'mscHistoryBillAddress.COMPANY_NAME', param.conditions, AdvancedSearchConsts.OPERATOR_LIKE.code).formatObj2Json()]
        } else {
          params.conditions = param.conditions
        }
        this.lastConditions = params.conditions
      } else {
        params.conditions = this.lastConditions
      }
      params.pageNum = this.pageConditions.pageNum
      params.pageSize = this.pageConditions.pageSize
      const loading = getLoading()
      mscHistoryBillAddressApi.queryAddressHistoryPageable(params).then(resp => {
        const data = resp.data
        this.pageConditions.pageSize = data.pageSize
        this.pageConditions.pageNum = data.pageNum
        this.pageConditions.total = Number(data.total)
        this.rowData = data.list
      }).finally(() => loading.close())
    },
    addHandler() {
      this.formDialog.uuid = ''
      this.formDialog.isEdit = true
      this.formDialog.visible = true
    },
    editHandler() {
      const cell = this.gridOptions.api.getFocusedCell()
      const selectedRow = cell ? this.rowData[cell.rowIndex] : null
      if (!selectedRow) {
        this.$message.warning(this.$t('Message.PleaseSelectARecord'))
        return
      }
      this.formDialog.isEdit = true
      this.formDialog.uuid = selectedRow.uuid
      this.formDialog.visible = true
    },
    removeHandler() {
      const cell = this.gridOptions.api.getFocusedCell()
      const selectedRow = cell ? this.rowData[cell.rowIndex] : null
      if (selectedRow) {
        this.$confirm(this.$t('SeaExport.WhetherDelete'), this.$t('SeaExport.Delete')).then(resp => {
          mscHistoryBillAddressApi.remove({ uuid: selectedRow.uuid }).then(resp => {
            this.rowData.splice(cell.rowIndex, 1)
          })
        })
      } else { // 请先选择需要操作的项目.
        this.$message.info(this.$t('SeaExport.PleaseChooseItem'))
      }
    },
    // 保存回调
    saveCallBackHandler(data) {
      const mscHistoryBillAddress = data
      if (mscHistoryBillAddress) {
        const loading = getLoading()
        mscHistoryBillAddressApi.save(mscHistoryBillAddress).then(resp => {
          this.pageConditions.pageNum = 1
          this.toQuery()
        }).finally(() => loading.close())
      }
      this.formDialog.visible = false
    },
    exportExcelSelectedHandler() {
      const rows = this.gridOptions.api.getSelectedRows()
      this.exportExcelHandler(rows)
    },
    exportExcelHandler(rows) {
      const rowData = rows || this.rowData
      if (!rowData || rowData.length === 0) return
      const columnDefs = []
      this.columnDefs.forEach(column => columnDefs.push({ colDef: column }))
      exportExcel('MSC提单地址', rowData, columnDefs)
    },
    exportPdfSelectedHandler(params) {
      const rows = this.gridOptions.api.getSelectedRows()
      this.exportPdfHandler(params, rows)
    },
    exportPdfHandler(params, rows) {
      const rowData = rows || this.rowData
      if (!rowData || rowData.length === 0) return
      const columnDefs = params.columnApi.getAllDisplayedColumns()
      exportPdf('MSC提单地址', rowData, columnDefs)
    }
  }
}
</script>

<style scoped>

</style>
